import './AddSchedule.scss';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const AddSchedule = ({ addScheduleToField }) => {

    const field = {
        name: "North Field",
        controllerId: "abc123-controller",
        zones: [
            { id: "zone-1", name: "Zone A" },
            { id: "zone-2", name: "Zone B" },
            { id: "zone-3", name: "Zone C" }
        ]
    };

    // Initialize component state variables
    const [selectedZone, setSelectedZone] = useState(null);
    const [selectedZoneId, setSelectedZoneId] = useState(null); // State to store the ID of the selected zone
    const [selectedZones, setSelectedZones] = useState([]);
    const [sequenceNumber, setSequenceNumber] = useState(1);
    const [duration, setDuration] = useState({ hours: '', minutes: '' });
    const [nextStartTime, setNextStartTime] = useState('');
    const [sequence, setSequence] = useState([]);
    const [scheduleName, setScheduleName] = useState('');
    const [schedule, setSchedule] = useState({});
    const [manualStart, setManualStart] = useState(false);

    const navigate = useNavigate();

    // Handler for when a zone is selected
    const handleZoneClick = (zoneName, zoneId) => {
        setSelectedZone(zoneName);
        setSelectedZoneId(zoneId); // Set the ID of the selected zone
    };

    // Handler for adding a zone to the selected zones
    const handleAddClick = () => {
        if (selectedZone) {
            const zoneData = {
                zone: selectedZone,
                zoneId: selectedZoneId, // Include the ID of the selected zone
                duration,
            };
            setSelectedZones([...selectedZones, zoneData]);
            setSequence([...sequence, zoneData]);
            setSelectedZone(null);
            setSelectedZoneId(null);
            setDuration({ hours: '', minutes: '' });
            setNextStartTime('');
        }
        setSequenceNumber(sequenceNumber + 1);
    };

    // Handler for changing the duration (hours and minutes)
    const handleDurationChange = (e) => {
        const { name, value } = e.target;
        setDuration({ ...duration, [name]: value });
    };

    // Handler for changing the next start time
    const handleNextStartTimeChange = (e) => {
        setNextStartTime(e.target.value);
    };

    // Handler for creating and adding a schedule
    const handleCreateSchedule = () => {
        //UN-COMMENT WHEN API CALL IS READY
        // const newSchedule = {
        //     scheduleName,
        //     nextStartTime,
        //     sequence,
        // };
        // // Set the schedule state variable with the new schedule object
        // addScheduleToField(field.controllerId, newSchedule);
        // setSchedule(newSchedule);
        navigate('/home/schedule');
    };

    // Handler for changing the schedule name
    const handleScheduleNameChange = (e) => {
        setScheduleName(e.target.value);
    };

    const updateZoneDuration = (index, type, value) => {
        const updatedZones = [...selectedZones];
        updatedZones[index].duration[type] = value;
        setSelectedZones(updatedZones);
        setSequence(updatedZones);
    };

    const moveZone = (index, direction) => {
        const newIndex = index + direction;
        if (newIndex < 0 || newIndex >= selectedZones.length) return;

        const updatedZones = [...selectedZones];
        const [movedZone] = updatedZones.splice(index, 1);

        // Clone the moved zone to ensure immutability
        const movedZoneClone = { ...movedZone, duration: { ...movedZone.duration } };

        updatedZones.splice(newIndex, 0, movedZoneClone);
        setSelectedZones([...updatedZones]); // force React to recognize change
        setSequence([...updatedZones]);      // same here
    };


    return (
        <div className='AddSchedule'>
            <h1>Create Schedule: {field.name}</h1>
            <label htmlFor="nameOfSchedule">Add Schedule Name</label>
            <input
                type="text"
                id="scheduleName"
                name="scheduleName"
                value={scheduleName}
                onChange={handleScheduleNameChange}
            />
            <div className='options-container'>
                <div className="zone-container">
                    <h2> Select Zone</h2>
                    <div className='zone-box'>
                        {field.zones &&
                            field.zones.map((zone, index) => (
                                <div
                                    key={index}
                                    className={`zone-options ${zone.name === selectedZone ? 'selected' : ''}`}
                                    onClick={() => handleZoneClick(zone.name, zone.id)}
                                >
                                    {zone.name}
                                </div>
                            ))}
                    </div>
                </div>
                <div className='add-container'>
                    <div className='duration-container'>
                        <label htmlFor="hours">Duration (hours):</label>
                        <input
                            type="number"
                            id="hours"
                            name="hours"
                            value={duration.hours}
                            onChange={handleDurationChange}
                            placeholder="Hours"
                        />
                        <label htmlFor="minutes">Duration (minutes):</label>
                        <input
                            type="number"
                            id="minutes"
                            name="minutes"
                            value={duration.minutes}
                            onChange={handleDurationChange}
                            placeholder="Minutes"
                        />
                    </div>
                    <button onClick={handleAddClick}>Add Zone</button>
                </div>
                <div className='sequence-container'>
                    <h2>Sequence</h2>
                    <div className='sequence-box'>
                        {selectedZones.map((zoneData, index) => (
                            <div key={index} className='sequence-item'>
                                <span>{index + 1}. {zoneData.zone}</span>
                                <div className="edit-controls">
                                    <label className='sequence-duration-input'>
                                        Hours:
                                        <input
                                            type="number"
                                            value={zoneData.duration.hours}
                                            onChange={(e) => updateZoneDuration(index, 'hours', e.target.value)}
                                        />
                                    </label>
                                    <label className='sequence-duration-input'>
                                        Minutes:
                                        <input
                                            type="number"
                                            value={zoneData.duration.minutes}
                                            onChange={(e) => updateZoneDuration(index, 'minutes', e.target.value)}
                                        />
                                    </label>
                                    <button onClick={() => moveZone(index, -1)} disabled={index === 0}>↑</button>
                                    <button onClick={() => moveZone(index, 1)} disabled={index === selectedZones.length - 1}>↓</button>
                                </div>
                            </div>
                        ))}

                    </div>
                </div>
            </div>
            <div className='datetime-container'>
                <label htmlFor="nextStartTime">Assign Next Start Time:</label>
                {!manualStart && (<input
                    type="datetime-local"
                    id="nextStartTime"
                    name="nextStartTime"
                    value={nextStartTime}
                    onChange={handleNextStartTimeChange}
                />)}
                <div className="manual-start-container">
                    <label>
                        <input
                            type="checkbox"
                            checked={manualStart}
                            onChange={() => setManualStart(!manualStart)}
                        />
                        Manual Start
                    </label>
                </div>

            </div>
            <button onClick={handleCreateSchedule}>Create Schedule</button>
        </div>
    );
};

export default AddSchedule;

